import dayjs from 'dayjs'
// 取随机数
export const randomString = len => {
  len = len || 32
  let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  let maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}
//  判断是否是谷歌浏览器
export const isChrome = () => {
  return navigator.userAgent.includes('Chrome')
}
// 转换时间
export const date2String = (value, format) => {
  if (!value) return ''
  return dayjs(value).format(format || 'YYYY-MM-DD')
}
